module.exports = __webpack_public_path__ + "img/pexels-andrea-piacquadio-3813341-minimized.36a1cc31.jpg";